import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Observable, Subject } from 'rxjs';
import { CodeSnippet } from './code-snippet.interface';


@Component({
    selector: 'iterate-object-snippet',
    template: `
        <clx-popover
            #editorwindow
            *ngIf="isDialogOpen"
            [minWidth]="300"
            [maxWidth]="800"
            class="popup"
            height="auto"
            width="auto"
            title="Interate Object"
            i18n-title="@@script-editor.snippet.iterate-object.popup.title"
            [(visible)]="isDialogOpen"
            (visibleChange)="visibilityChanged($event)"
        >

            <div
                class="error message"
                *ngIf="error"
                i18n="@@script-editor.snippet.popup.message.plant-missing"
            >Please choose a plant/system before adding a datapoint</div>
            <clx-row
                has="full-size-columns big-layout">
                <clx-item>
                <clx-checkbox name="addarray"
                    #addarray
                    value="true"
                    selected="true">
                </clx-checkbox><clx-label>add example-object and -access</clx-label>

                </clx-item>
            </clx-row>

            <clx-row has="full-size-columns big-layout">
                <clx-label>Variable name</clx-label>
                <clx-item>
                    <clx-input
                        name="varname"
                        #varname
                        value="object"
                    >
                        <clx-validation type="required"></clx-validation>
                    </clx-input>

                </clx-item>
            </clx-row>
            <clx-row has="full-size-columns big-layout">
                <clx-label>Key variable</clx-label>
                <clx-item>
                    <clx-input
                        name="idxname"
                        #idxname
                        value="key"
                    >
                        <clx-validation type="required"></clx-validation>
                    </clx-input>

                </clx-item>
            </clx-row>
            <clx-row has="full-size-columns big-layout">
                <clx-label>value variable</clx-label>
                <clx-item>
                    <clx-input
                        name="itemname"
                        #itemname
                        value="value"
                    >
                        <clx-validation type="required"></clx-validation>
                    </clx-input>

                </clx-item>
            </clx-row>

            <clx-row
                *ngIf="!systemId"
                type="buttons">
                <clx-button
                    i18n="@@script-editor.snippets.act-on-plant.button"
                    (click)="selectDatapoint({ varname: varname.value, itemname: itemname.value, idxname: idxname.value, addarray: addarray.value })"
                >Add</clx-button>
            </clx-row>

        </clx-popover>
    
    `,
    standalone: false
})
export class IterateObjectSnippet implements CodeSnippet{

    text : string = $localize`:@@script-editor.snippet.iterate-object:iterate object`;

    static category: string = 'common';

    data: any;

    error: boolean = false;

    isDialogOpen: boolean = false;

    subject: Subject<any> = new Subject();

    observable: Observable<any> = this.subject.asObservable()

    part = true;

    selectDatapoint(v) {
        this.subject.next(v);
        this.subject.complete();
    }


    async insert(): Promise<string> {

        this.subject = new Subject();
        this.observable = this.subject.asObservable();
        this.isDialogOpen = true;
        this.error = true;
        this.error = false;
        const value = await lastValueFrom(this.observable);
        this.isDialogOpen = false;

        if (!value)
            return '';

        let str = ``

        if (value.addarray)
            str += `    -- example object
    local ${value.varname} = 
    { 
        a = 123, 
        b = "Hallo",
        n = true
    }
`

        str += `
    -- iterates keys and values of an object`

        if (value.addarray)
        str += `
    -- REMINDER: objects do not have a stable key order so the output may vary in order`

    str += `
    for ${value.idxname}, ${value.itemname} in pairs(${value.varname}) do

        �-- operate on ${value.idxname} / ${value.itemname}`;

        if (value.addarray)
            str += `
        show("KEY: {0} - VALUE: {1}", ${value.idxname}, ${value.itemname})`


        str += `�

    end
`
        return str;
    }
}